import { render, staticRenderFns } from "./SpecialBox.vue?vue&type=template&id=3e272580&"
import script from "./SpecialBox.vue?vue&type=script&lang=js&"
export * from "./SpecialBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports